import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, Toaster } from "react-hot-toast";
import { BASE_URL } from "../BaseURL";
import "../Assets/Css/contact.css";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Card,
} from "react-bootstrap";
import { IoIosSend } from "react-icons/io";
import contactbg from "../Assets/Image/contact1-img.jpg";
import { Helmet } from "react-helmet";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    mobile: "",
    address: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    toast.loading("Sending your message...");

    try {
      const res = await axios.post(
        `${BASE_URL}/enquiry/sendContactEnquiry`,
        formData
      );
      toast.dismiss();
      toast.success(res.data.message || "Enquiry sent!");
      setFormData({
        userName: "",
        email: "",
        mobile: "",
        address: "",
        message: "",
      });
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.error || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Contact Us | Delta Engineering</title>
        <meta
          name="description"
          content="Reach out to Delta Engineering for any queries related to our electrical components, engineering solutions, or services. Contact our Sales, Product Development, or Support teams."
        />
        <meta
          name="keywords"
          content="Contact Delta Engineering, sales support, product enquiry, Delta contact details, engineering solutions support"
        />
        <meta name="author" content="Delta Engineering" />
        <meta property="og:title" content="Contact Us | Delta Engineering" />
        <meta
          property="og:description"
          content="We’re here to assist you with any queries or services. Reach out to Delta Engineering’s departments for quick support."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deltaengnsk.com/contact" />
        <meta property="og:site_name" content="Delta Engineering" />
      </Helmet>
      <Toaster />

      <section className="contact-banner d-flex align-items-center justify-content-center text-center position-relative">
        <div className="contact-overlay-layer"></div>
        <div className="banner2-overlay text-center text-white w-100 px-4 px-md-5 position-relative z-2">
          <h1
            className="banner2-title mb-2"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            CONTACT<span> US</span>
          </h1>
          <p
            className="banner2-subtitle"
            data-aos="zoom-in"
            data-aos-delay="200"
            style={{ color: "white" }}
          >
            We’re here to assist you with any queries or services.
          </p>
        </div>
      </section>

      <section className="contact-section py-2 bg-light pt-0">
        <Container>
          <Row className="text-center mb-4" data-aos="zoom-in">
            <Col>
              <h3
                className="fw-bold section-title mt-3 mb-2 text-primary"
                data-aos="fade-down"
              >
                GET IN TOUCH 
                <span className="title-underline"></span>
              </h3>

              <p className="text-muted px-3 px-md-5">
                Reach out to the appropriate department for faster assistance.
                We’re here to help you with any queries regarding our services
                or products.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center g-4 text-center mt-2 align-items-stretch">
            <Col md={4} data-aos="fade-up">
              <Card className="contactcard border-0 shadow h-100">
                <Card.Body>
                  <h5 className="fw-bold mb-3">Sales & Marketing</h5>
                  <p className="mb-2">
                    <a
                      href="tel:+919021399351"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <FaPhoneAlt className="me-2 text-success" />
                      +91 9021399351
                    </a>
                  </p>

                  <p className="mb-0">
                    <FaEnvelope className="me-2 text-danger" />
                    <a
                      href="mailto:rahees@deltaen.in"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      rahees@deltaen.in
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="fade-up" data-aos-delay="100">
              <Card className="contactcard border-0 shadow h-100">
                <Card.Body>
                  <h5 className="fw-bold mb-3">Product Development</h5>
                  <p className="mb-2">
                    <a
                      href="tel:+917588319690"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <FaPhoneAlt className="me-2 text-success" />
                      +91 7588319690
                    </a>
                  </p>

                  <p className="mb-2">
                    <FaEnvelope className="me-2 text-danger" />
                    <a
                      href="mailto:rahul@deltaen.in"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      rahul@deltaen.in
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="fade-up" data-aos-delay="200">
              <Card className="contactcard border-0 shadow h-100">
                <Card.Body>
                  <h5 className="fw-bold mb-3">General Queries</h5>
                  <p className="mb-2">
                    <FaEnvelope className="me-2 text-danger" />
                    <a
                      href="mailto:info@deltaen.in"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      info@deltaen.in
                    </a>
                  </p>
                  <p className="mb-0">
                    <FaGlobe className="me-2 text-success" />
                    <a
                      href="https://deltaen.in"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      deltaen.in
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className="cta-section mb-4 d-flex align-items-center"
        style={{
          backgroundImage: `url(${contactbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
        loading="lazy"
      >
        <Container className="p-4">
          <Row className="justify-content-center">
            <Col md={8} className="contactform p-5" data-aos="zoom-in">
              <h4 className="titleclr fw-bold text-center">
                Send Us a Message
              </h4>
              <Form className="mt-3" onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label>Your Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="userName"
                        placeholder="Enter your name"
                        value={formData.userName}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formMobile">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter your mobile number"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="animated-input"
                        maxLength={10}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAddress">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        placeholder="Enter your address"
                        value={formData.address}
                        onChange={handleChange}
                        className="animated-input"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={4}
                    placeholder="Type your message here"
                    value={formData.message}
                    onChange={handleChange}
                    className="animated-input"
                  />
                </Form.Group>

                <div className="mt-3 d-flex justify-content-center">
                  <Button
                    className="btn-banner p-2"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Sending...
                      </>
                    ) : (
                      <>
                        <IoIosSend className="fs-4 me-2" /> Send Message
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="map-section mt-5">
        <Container className="p-0">
          <Row className="text-center mb-4 m-0" data-aos="zoom-in">
            <Col>
              <h3
                className="fw-bold text-center section-title"
                data-aos="fade-down"
              >
                Find Us On the Map
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>
          {/* <iframe
            title="Delta Engineering Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25041.49445821303!2d73.70185781083981!3d19.95117920000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb2c4362fc25%3A0x3b87e01799752e42!2sDELTA%20ENGINEERING!5e1!3m2!1sen!2sus!4v1753092680186!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          /> */}
          <iframe
            title="Delta Engineering Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.0554400046058!2d73.7370092!3d19.9641706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeca52699e4e3%3A0x43e896d40c2f7393!2sD%2F1%2C%20D1%2F32%2C%20MIDC%20Ambad%2C%20Nashik%2C%20Maharashtra%20422010!5e0!3m2!1sen!2sin!4v1758604910991!5m2!1sen!2sin"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </Container>
      </section>
    </div>
  );
}
